import Header from "../components/Header";
import capdothuong from "@/assets/img/thamvan/capdothuong.jpg";
import axios from "@/shared/config/axios-interceptor";
import { useEffect, useState } from "react";

const ThamVan = () => {
  const [data, setData] = useState<any>("");
  const getData = async () => {
    try {
      const res = await axios.get("/settings/1");
      setData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="wrapper">
      <div className="container-web thanvan bgnew">
        <Header title="Tham vấn" />
        <main>
          <img src={data?.content1} className="w-100" />
        </main>
      </div>
    </div>
  );
};

export default ThamVan;
